import styled from "styled-components";

export const EventCompStyle = styled.div`
  display: inline-block;
  margin: 0 5px 10px;
  padding: 0.5em 1.5em 1.5em;
  max-width: 90%;
  background: #00a756;
  text-align: center;
  font-size: 17px;
  color: #ffffff;

  &.full {
    background: #aaaaaa;
  }

  &.upon-request {
    background: #007056;
  }

  .event-name {
    font-size: 1.3em;
    font-weight: bold;
  }

  a {
    text-decoration: none;
    color: #ffffff;
  }

  &.has-colour {
    color: #000000;

    a {
      text-decoration: none;
      color: #000000;
    }
  }

  &.has-promo {
    .event-description strong {
      font-family: "Chewy", serif;
      font-weight: 400;
      font-size: 1.5em;
      font-style: normal;
      color: #ffffff;
      text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.8),
        0px 2px 10px rgba(0, 0, 0, 0.4);
    }
  }

  &.with-image {
    padding: 2em;
    width: 100%;
    border-radius: 1em;
    text-align: left;

    .event-img {
      float: left;
      width: 30%;
      margin: 0 2em 0 0;
      border-radius: 0.5em;
    }

    &:nth-child(even) {
      .event-img {
        float: right;
        margin: 0 0 0 2em;
      }
    }

    .event-name {
      margin: 0 0 0.4em;
      font-size: 2em;
      font-weight: bold;
      opacity: 0.7;
    }

    .event-date {
      margin: 0.3em 0;
      font-size: 1.3em;
      font-weight: bold;
    }

    .event-description {
      font-size: 1.2em;
      white-space: pre-wrap;
    }

    .register-btn {
      margin: auto;
      width: 50%;
      outline: dotted 6px #cccccc;
      border-radius: 0.5em;
      font-size: 1.3em;
    }

    @media (max-width: 600px) {
      .event-img {
        float: none;
        width: 100%;
      }

      .event-name {
        margin: 0.7em 0;
        font-size: 1.5em;
      }

      &:nth-child(even) {
        .event-img {
          float: none;
          margin: 0;
        }
      }

      .register-btn {
        width: 100%;
      }
    }
  }
`;

export const EventRegisterBtn = styled.button`
  display: block;
  border: solid 3px green;
  border-radius: 10px;
  width: 100%;
  line-height: 2.5em;
  background: #c1e1c1;
  font-size: 0.8em;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0px 10px 20px -10px rgba(0, 0, 0, 0.5);

  &.hasColour {
    background: #efefef;
  }
`;
